export default
{
  type: "form-phone",
  style: "",
  data: {
    label: "New Phone Field",
    placeholder: "123456789",
    options: [
      {label: "+852 🇭🇰", value: "852"},
      {label: "+86 🇨🇳", value: "86"},
      {label: "+853 🇲🇴", value: "853"},
    ],
  },
  children: [],
};
